module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-3.a79e9241.png";